"use strict";
/** @module utils */
/**
 * File containing functions to get and format information about
 * the device being used to access the site.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceInfo = exports.getDeviceName = void 0;
var platform = require("platform");
/**
 * Get device name.
 * @param siteName Name of site device name being gotten for.
 * @return Formatted device name.
 */
function getDeviceName(siteName) {
    var deviceSuffix = (platform.name != null
        && platform.os != null
        && platform.os.family != null) ? " - " + platform.name + " (" + platform.os.family + ")" : '';
    return siteName + deviceSuffix;
}
exports.getDeviceName = getDeviceName;
/**
 * Get device info.
 * @return Device info.
 */
function getDeviceInfo() {
    return {
        description: platform.description,
        layout: platform.layout,
        manufacturer: platform.manufacturer,
        name: platform.name,
        prerelease: platform.prerelease,
        product: platform.product,
        ua: platform.ua,
        version: platform.version,
        os: {
            architecture: platform.os && platform.os.architecture,
            family: platform.os && platform.os.family,
            version: platform.os && platform.os.version,
        },
    };
}
exports.getDeviceInfo = getDeviceInfo;
//# sourceMappingURL=device.js.map